/* global G */
import { asyncPipeSpread } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import { getNotification } from 'app/notification/action/partials/getNotification'
import { displayOptions } from 'app/notification/action/partials/displayOptions'

/**
 * Notification EditAlert Action
 *
 * @param {Gaia.AppModule.Spec} module current module composition
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
export default module => () => async (...args) => asyncPipeSpread(
  getNotification('alert')(module),
  displayOptions(module),
)(find(module[G.STATE][G.ACTION][G.COMPONENT]), ...args)
